
/**
 * 员工等级铭牌（StaffNameplate）
 * 固定 4 级：Lv1 成员 / Lv2 熟练 / Lv3 资深 / Lv4 核心
 * 资深、核心开启扫光。尺寸与 MemberNameplate V2 对齐（30px 高 / 12px 字）。
 * prefix：可选头衔前缀（如角色名），有则显示为「头衔·等级」（例：管理员·成员）。
 */
const STAFF_LEVELS = [
  { level: 1, minXp: 0, name: '成员' },
  { level: 2, minXp: 100, name: '熟练' },
  { level: 3, minXp: 300, name: '资深' },
  { level: 4, minXp: 800, name: '核心' }
]

export default {
  name: 'StaffNameplate',
  props: {
    level: { type: Number, default: 1 },
    prefix: { type: String, default: '' }
  },
  computed: {
    lvClass () {
      return 'sp-lv' + Math.min(4, Math.max(1, this.level || 1))
    },
    name () {
      const lv = Math.min(4, Math.max(1, this.level || 1))
      return STAFF_LEVELS[lv - 1].name
    },
    displayText () {
      return this.prefix ? this.prefix + '·' + this.name : this.name
    }
  }
}
